(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ef-ritual-modes"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initRitualCarousels(root) {
      var scope = root && root.querySelectorAll ? root : document;
      var rows = scope.querySelectorAll('[data-ef-ritual-carousel]');
      Array.prototype.forEach.call(rows, function (row) {
        if (row.hasAttribute('data-ef-ritual-ready')) return;
        row.setAttribute('data-ef-ritual-ready', '');
        var section = row.closest('.ef-section');
        if (!section) return;
        var dots = section.querySelectorAll('.ef-ritual__dot');
        var cards = row.querySelectorAll('.ef-ritual__card');
        if (!dots.length || !cards.length) return;
        var ticking = false;
        var update = function () {
          ticking = false;
          var max = row.scrollWidth - row.clientWidth;
          var idx = 0;
          if (max > 0 && cards.length > 1) {
            idx = Math.round((row.scrollLeft / max) * (cards.length - 1));
          }
          if (idx < 0) idx = 0;
          if (idx > dots.length - 1) idx = dots.length - 1;
          Array.prototype.forEach.call(dots, function (dot, i) {
            dot.classList.toggle('is-active', i === idx);
          });
        };
        row.addEventListener(
          'scroll',
          function () {
            if (!ticking) {
              ticking = true;
              window.requestAnimationFrame(update);
            }
          },
          { passive: true }
        );
        update();
      });
    }
    initRitualCarousels(document);
    document.addEventListener('shopify:section:load', function (evt) {
      initRitualCarousels(evt.target);
    });

    /* Mobile scroll-scrub: while scrolling down past this section, pin it
       and convert vertical scroll into horizontal card travel, then release
       and continue down (GSAP ScrollTrigger, already vendored — loaded on
       demand via EF.ensureGsap). Guards: phones only, motion enabled, row
       actually overflows. Falls back to the plain swipe carousel. */
    function initRitualScrub() {
      if (!window.matchMedia('(max-width: 767.98px)').matches) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      if (!document.documentElement.classList.contains('ef-motion')) return;
      if (!window.EF || !window.EF.ensureGsap) return;
      var rows = document.querySelectorAll('.ef-ritual__row--grid');
      Array.prototype.forEach.call(rows, function (row) {
        if (row.hasAttribute('data-ef-scrub')) return;
        var sec = row.closest('.ef-section');
        if (!sec) return;
        var dist = row.scrollWidth - row.clientWidth;
        if (dist < 60) return;
        row.setAttribute('data-ef-scrub', '');
        window.EF.ensureGsap().then(function (gsap) {
          row.style.scrollSnapType = 'none';
          var proxy = { p: row.scrollLeft };
          gsap.to(proxy, {
            p: dist,
            ease: 'none',
            scrollTrigger: {
              trigger: sec,
              start: 'top 12%',
              end: '+=' + Math.max(dist, 320),
              pin: true,
              scrub: 0.4,
              anticipatePin: 1,
              invalidateOnRefresh: true
            },
            onUpdate: function () { row.scrollLeft = proxy.p; }
          });
        });
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initRitualScrub);
    } else {
      initRitualScrub();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
